import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import ReportFraConditionsMasterKey from "../../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { switchReportStyle } from "../../sims/style";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import {
  InspectionReportHeader,
  InspectionsReportSchema,
  SystemInspectionComment,
  SystemInspectionInfo,
  SystemInspectionReport,
} from "./InspectionReportSchema";
import React from "react";
const masterKey = [
  {
    key: "C",
    value: "Tests completed on all applicable components, no exceptions found, and condition left in compliance.",
  },
  {
    key: "A",
    value: "Adjustments made (identified in associated comments), test completed, and condition left in compliance.",
  },
  {
    key: "R",
    value: "Repairs and/or Replacements made (identified in associated comments), test completed, and condition left in compliance.",
  },
  {
    key: "NC",
    value: "Needs Correction.",
  },
  {
    key: "N/A",
    value: "Not Applicable",
  },
];

const SDMTSInspectionReport = (props) => {
  const { reportData } = props;

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let grouped = ReportGroupingUtils.filterReportsByTestCodesAndUpdateDuplicateTestCodes(reportsByDateAndUser, [
    "sdmtsOverheadCatenarySystem",
  ]);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(grouped);

  return decodedReports.map((report, i) => <ViewReport key={i} data={report} {...props} />);
};

const ViewReport = (props) => {
  const { data, completeAsset } = props;
  const { decodedData } = data;

  let trackInfo = getTrackInfoFromAsset(completeAsset);

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="Overhead Catenary System" {...props} fontSizeOverride={"35px"} />
      <span className="spacer"></span>

      <ReportFraInfoSectionContainer {...props} data={{ ...data }} />
      <ReportFraConditionsMasterKey masterKey={masterKey} />
      {decodedData.map((singleReport, index) => (
        <div key={index}>
          <span className="spacer"></span>
          <table className="table-bordered">
            {InspectionReportHeader.map((section, key) => (
              <ReportTableSectionRenderer key={key} section={section} rowsData={{ ...singleReport.summary, ...trackInfo }} />
            ))}
          </table>
          <table className="table-bordered">
            {InspectionsReportSchema.map((section, key) => (
              <ReportTableSectionRenderer key={key} section={section} rowsData={singleReport.summary} />
            ))}
          </table>
          <table className="table-bordered">
            <ReportTableSectionRenderer section={SystemInspectionReport} rowsData={singleReport.summary.defect || []} />
          </table>
          <table className="table-bordered">
            {SystemInspectionComment.map((section, key) => (
              <ReportTableSectionRenderer key={key} section={section} rowsData={singleReport.summary} />
            ))}
          </table>
          <table className="table-bordered">
            {SystemInspectionInfo.map((section, key) => (
              <ReportTableSectionRenderer key={key} section={section} rowsData={singleReport.summary} />
            ))}
          </table>
        </div>
      ))}
    </div>
  );
};

export default SDMTSInspectionReport;

function getTrackInfoFromAsset(asset) {
  if (!asset || !asset.attributes)
    return {
      trackDirection: null,
      trackNumber: null,
      start: null,
      end: null,
    };

  return {
    trackDirection: asset.attributes["Track Direction"],
    trackNumber: asset.attributes["Track #"],
    start: asset.attributes["Start"],
    end: asset.attributes["End"],
  };
}



// WEBPACK FOOTER //
// ./src/components/Reports/SDMTS/InspectionReportForm/index.jsx